<template>
  <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary" rounded="sm">
    <b-card class="mt-2 mx-0 border-none p-0">
      <b-card-header id="orderuninvoiced-card-header" class="pl-2 pr-3 small">
        Uninvoiced Scheduled Payment
      </b-card-header>
      <b-tooltip target="orderuninvoiced-card-header" triggers="hover"
        >Uninvoiced Scheduled Payments</b-tooltip
      >
      <b-card-body class="px-0 pt-0">
        <b-table
          v-if="options.showtable"
          ref="logtable"
          id="logtable"
          striped
          sticky-header="205px"
          fixed
          small
          bordered
          :items="items"
          :fields="options.fields"
          class="gridtable my-0"
        >
          <template v-slot:cell()="row">
            <div
              v-if="
                options.badges &&
                options.badges.find((obj) => obj.key == row.field.key)
              "
            >
              <span
                v-html="
                  $helpers.badgeField(
                    row.item,
                    options.badges.find((obj) => obj.key == row.field.key),
                    options
                  )
                "
              ></span>
            </div>
            <div v-else>{{ row.value }}</div>
          </template>
        </b-table>
        <b-row class="excelsheetbuttons">
          <b-col class="text-right">
            <b-link
              id="orderuninvoiced-excel"
              class="mt-1 excel"
              @click="$helpers.outputExcel({ items, fields: options.fields })"
              title="Send to excel"
            >
              <i class="fa fa-file-excel-o" aria-hidden="true"></i>
            </b-link>
            <b-tooltip target="orderuninvoiced-excel" triggers="hover"
              >Grid to excel</b-tooltip
            >
          </b-col>
        </b-row>
        <b-row class="mt-2 mb-2">
          <b-col>
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
              <span class="small text-primary ml-2">Updating ...</span>
            </div>
            <span v-if="!busy" class="small text-primary"
              >Showing {{ options.items.length }} uninvoiced payment(s)</span
            >
            <br />
            <span v-if="!busy" class="small text-primary">{{
              options.actionmessage
            }}</span>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";
import moment from "moment";

export default {
  name: "OrderUninvoiced",
  props: ["tile", "refresh"],
  data() {
    return {
      busy: false,
      timeout: false,
      name: "OrderUninvoiced",
      options: {
        // lastrunstatus: "success",
        timestamp: "Unknown",
        running: false,
        actionmessage: "",
        status: "negative",
        showtable: true,
        format: "grid",
        fields: [
          {
            key: "yourref",
            label: "Your Ref / PO",
            sortable: true,
          },
          {
            key: "daterequired",
            label: "Date Required",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment.unix(value / 1000).format("DD/MM/YYYY");
              }
              return result;
            },
          },

          {
            key: "slac",
            label: "SL A/C",
            sortable: true,
          },
          {
            key: "eventcode",
            label: "Event",
            sortable: true,
          },
          {
            key: "ref",
            label: "Ref",
            sortable: true,
            class: "d-none d-xl-table-cell",
          },
          {
            key: "datedue",
            label: "Due Date",
            sortable: true,
            sortDirection: "desc",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment.unix(value / 1000).format("DD/MM/YYYY");
              }
              return result;
            },
          },
          // {
          //   key: "valuetotal",
          //   label: "Value",
          //   sortable: true,
          //   class: "text-right",
          //   formatter: (value, key, item) => {
          //     if (value) {
          //       return parseFloat(value).toFixed(2);
          //     } else {
          //       return value;
          //     }
          //   },
          // },
          {
            key: "agent",
            label: "Agent",
            sortable: true,
            class: "d-none d-xl-table-cell",
          },
        ],
        items: [],
        badges: [
          {
            key: "status",
            type: "badge",
            Invoiced: "primary",
            Cancelled: "danger",
            New: "info",
            Pending: "warning",
            Failed: "danger",
            Vouchered: "warning",
            Queued: "secondary",
            "On Hold": "warning",
            formatter: (value, key, item) => {
              switch (value) {
                case "ID":
                  return "Invoiced";
                  break;
                case "AA":
                  return "On Hold";
                  break;
                case "CX":
                  return "Cancelled";
                  break;
                case "IF":
                  return "Failed";
                  break;
                case "IQ":
                  return "Queued";
                  break;
                case "ST":
                  return "New";
                  break;
                case "VD":
                  return "Vouchered";
                  break;
                case "WI":
                  return "Pending";
                  break;
                default:
                  return value;
              }
            },
          },
        ],
      },
    };
  },
  async mounted() {
    this.$helpers.resizableColumns();
    await this.loadChart();
  },
  watch: {
    refresh: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.loadChart();
      },
    },
    tile: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.loadChart();
      },
    },
  },
  computed: {
    items() {
      return this.options.items;
    },
    chartType() {
      if (this.tile.settings) {
        let setting = this.tile.settings.find((o) => o.key == "type");
        return setting.value;
      } else {
        return "Table";
      }
    },
  },
  methods: {
    async loadChart() {
      console.log("loadChart: orderuninvoiced");

      let variables = {
        dateplacedfrom: moment().add(-3, "months").format("YYYY-MM-DD"),
        dateplacedto: moment().add(6, "months").format("YYYY-MM-DD"),
      };
      console.log("variables", variables);

      this.busy = true;
      try {
        const response = await this.$apollo.query({
          query: gql`
            query chart_ordersuninvoiced(
              $dateplacedfrom: String
              $dateplacedto: String
            ) {
              chart_ordersuninvoiced(
                dateplacedfrom: $dateplacedfrom
                dateplacedto: $dateplacedto
              ) {
                yourref
                daterequired
                reason
                slac
                eventcode
                agent
                ref
                datedue
              }
            }
          `,
        });
        console.log(response);
        this.options.items = response.data.chart_ordersuninvoiced;
      } catch (error) {
        console.log(error);
      }

      this.busy = false;
      await this.$emit("refreshed");
    },
  },
};
</script>


<style>
</style>